<template>
  <div class="circle-progress" :class="'circle'+id">
    <div class="canvas-box">
        <canvas :id="'circle'+id" width="140" height="140"></canvas>
        <span>{{score}}%</span>
    </div>
    <p>{{name}}</p>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</template>
<script>
export default {
  props: ['id','name','score'],
  data () {
    return {
      color:['#ef7b7c','#ffbb4f','#01abc5'],
    }
  },
  mounted(){
    // let score = this.score/100*Math.PI*2+Math.PI/2
    let score = (this.score+25)*Math.PI/50
    var ctx=document.getElementById('circle'+this.id).getContext("2d");
    ctx.lineWidth = 13
    ctx.strokeStyle = "#ebebeb";
    ctx.arc(70,70,60,0,2*Math.PI);
    ctx.stroke();
    ctx.beginPath();
    ctx.strokeStyle = this.color[this.id];
    ctx.arc(70,70,60,Math.PI/2,score);
    ctx.stroke();
  },
  methods:{
    
  }
}
</script>
<style scoped>
.canvas-box{position: relative;}
canvas{width: 140px;height: 140px;}
.canvas-box span{position: absolute;top: 8px;left: 8px;font-weight: bold;font-size: 18px;}
p{line-height: 16px;font-size: 15px;margin-bottom: 5px;}
.line{height: 2px;background: #ccc;width: 114px;margin: 0 auto 5px;}
.circle0 .canvas-box{position: relative;background: url('../../assets/img/report/ring_1_v2.png') no-repeat;background-position:center;background-size: 48px 48px; }
.circle1 .canvas-box{position: relative;background: url('../../assets/img/report/ring_2_v2.png') no-repeat;background-position:center;background-size: 48px 48px; }
.circle2 .canvas-box{position: relative;background: url('../../assets/img/report/ring_3_v2.png') no-repeat;background-position:center;background-size: 48px 48px; }
.circle0 .canvas-box span{color:#ef7b7c;}
.circle1 .canvas-box span{color:#ffbb4f;}
.circle2 .canvas-box span{color:#01abc5;}
.circle0 p{color:#ef7b7c;}
.circle1 p{color:#ffbb4f;}
.circle2 p{color:#01abc5;}
.circle0 .line{background: #ef7b7c;}
.circle1 .line{background: #ffbb4f;}
.circle2 .line{background: #01abc5;}
</style>


// WEBPACK FOOTER //
// src/components/circle/circle.vue